import { Context, createContext, CSSProperties, ReactElement, ReactNode, useContext } from 'react';
import { explodingObject } from '../../util/contextHelpers';
import { Option } from '@components/form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BaseItem = Record<string, any>;

export interface FilterMenuProps<TItem extends BaseItem> {
    title?: ReactNode;

    selected?: TItem[];
    selectAll?: boolean;
    selectBlanks?: boolean;
    onSelect?: (selected: TItem[], selectAll: boolean, selectBlanks: boolean) => void;

    showDisplayOptions?: boolean;
    selectedDisplay?: string;
    displayOptions?: Option<string>[];
    onSelectDisplay?: (selected: string) => void;

    autoApply?: boolean;
    multiselect?: boolean;
    filtered?: boolean;

    canSelectAll?: boolean;
    canSelectBlanks?: boolean;
    canToggleBlanks?: boolean;
    canToggleMultiselect?: boolean;
    canToggleAutoApply?: boolean;

    toggleMultiselect?: () => void;
    toggleBlanks?: () => void;
    toggleAutoApply?: () => void;

    blanksLabel?: string;

    searchLabel?: string;
    searchable?: boolean;

    removeable?: boolean;
    removeIcon?: ReactElement;
    removeLabel?: string;
    onRemove?: () => void;

    options: TItem[];
    maxItems?: number;
    menuOffset?: number;
    menuWidth?: number;

    getValue(option: TItem): string | number;
    getLabel(option: TItem): string;
    getItemStyle?(option: TItem): CSSProperties;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FilterMenuContext = createContext<FilterMenuProps<any>>(
    explodingObject('Filter menu context used without being provided')
);

export function useFilterMenu<TItem extends BaseItem>() {
    return useContext(FilterMenuContext as Context<FilterMenuProps<TItem>>);
}
